<template>
    <div class="contain">
        <ManageHeaderMenu></ManageHeaderMenu>
        <div class="main">
            <ManageMenu defaultActive="1-1"></ManageMenu>
            <div class="content">
                <div class="content-title">
                    <span>{{ pageName }}：数量 {{ pagination.total }}</span>
                    <el-button style="margin-left: auto;" class="content-title-button" @click="refresh">刷新数据</el-button>
                    <el-button class="content-title-button" @click="drawer = true">添加数据</el-button>
                </div>
                <div style="padding: 20px;">
                    <el-table :data="tableData" border class="custom-table">
                        <el-table-column prop="ip" label="服务器 IP 地址">
                            <template slot-scope="scope">
                                <i class="el-icon-monitor"></i>
                                <span style="margin-left: 10px">{{ scope.row.ip }}</span>
                            </template>
                        </el-table-column>

                        <el-table-column prop="bt_username" label="服务器信息">
                            <template slot-scope="scope">
                                <el-popover trigger="hover" placement="top">
                                    <p style="margin-bottom: 5px;">系统账号：{{ scope.row.root_username }}</p>
                                    <p style="margin-bottom: 5px;">系统密码：{{ scope.row.root_password }}</p>
                                    <p style="margin-bottom: 5px;">宝塔账号：{{ scope.row.bt_username }}</p>
                                    <p style="margin-bottom: 5px;">宝塔密码：{{ scope.row.bt_password }}</p>
                                    <p style="margin-bottom: 5px; display: flex; align-items: center;">
                                        宝塔地址：<el-link target="_blank" :href="scope.row.bt_address"
                                            type="info">访问链接</el-link>
                                    </p>
                                    <div slot="reference" class="name-wrapper">
                                        <el-tag size="medium">{{ scope.row.system }}</el-tag>
                                    </div>
                                </el-popover>
                            </template>
                        </el-table-column>
                        <el-table-column prop="info" label="云服务商">
                            <template slot-scope="scope">
                                <el-popover trigger="hover" placement="top">
                                    <p style="margin-bottom: 5px;">备注信息：{{ scope.row.info }}</p>
                                    <div slot="reference" class="name-wrapper">
                                        <el-tag size="medium">{{ scope.row.operator }}</el-tag>
                                    </div>
                                </el-popover>
                            </template>
                        </el-table-column>
                        <el-table-column prop="price" label="服务器价格">
                            <template slot-scope="scope">
                                <div style="font-family: Courier; font-weight: bolder;">¥ {{ scope.row.price | formatPrice }}</div>
                            </template>
                        </el-table-column>
                        <el-table-column prop="expiration_date" label="过期时间">
                            <template slot-scope="scope">
                                <i class="el-icon-time"></i>
                                <span style="margin-left: 10px; font-family: Courier; font-weight: bolder;">{{ scope.row.expiration_date }}</span>
                            </template>
                        </el-table-column>
                        <el-table-column label="操作" align="center">
                            <template slot-scope="scope">
                                <el-button class="table-button" size="mini" @click="updateData(scope.row)">编辑</el-button>
                                <el-popconfirm confirm-button-text='确定' cancel-button-text='取消'
                                    confirm-button-type="primary" cancel-button-type="info" title="温馨提示：是否确定删除当前数据"
                                    @confirm="deleteData(scope.row)">
                                    <el-button plain type="danger" class="table-button" size="mini"
                                        slot="reference">删除</el-button>
                                </el-popconfirm>
                            </template>
                        </el-table-column>
                    </el-table>
                    <div
                        style="background-color: #ffffff; height: 50px; display: flex; align-items: center; margin-top: 20px;">
                        <el-pagination @current-change="changePage" background layout="prev, pager, next"
                            :total="pagination.total">
                        </el-pagination>
                    </div>
                </div>
            </div>
        </div>

        <el-drawer :title="`${pageName} ${form.id == '' ? '添加数据' : '更新数据'}`" style="z-index: 1;" :visible.sync="drawer"
            direction="ltr" :before-close="handleClose">
            <div class="custom-form">
                <el-form :model="form">
                    <el-form-item label="服务器 IP 地址">
                        <el-input v-model="form.ip" placeholder="服务器 IP 地址" autocomplete="off"></el-input>
                    </el-form-item>
                    <el-form-item label="云服务商">
                        <el-input v-model="form.operator" placeholder="云服务商" autocomplete="off"></el-input>
                    </el-form-item>
                    <el-form-item label="服务器价格">
                        <el-input type="number" v-model="form.price" placeholder="服务器价格" autocomplete="off"></el-input>
                    </el-form-item>
                    <el-form-item label="系统类型">
                        <el-input v-model="form.system" placeholder="系统类型" autocomplete="off"></el-input>
                    </el-form-item>
                    <el-form-item label="系统账号">
                        <el-input v-model="form.root_username" placeholder="系统账号" autocomplete="off"></el-input>
                    </el-form-item>
                    <el-form-item label="系统密码">
                        <el-input v-model="form.root_password" placeholder="系统密码" autocomplete="off"></el-input>
                    </el-form-item>
                    <el-form-item label="宝塔账号">
                        <el-input v-model="form.bt_username" placeholder="宝塔账号" autocomplete="off"></el-input>
                    </el-form-item>
                    <el-form-item label="宝塔密码">
                        <el-input v-model="form.bt_password" placeholder="宝塔密码" autocomplete="off"></el-input>
                    </el-form-item>
                    <el-form-item label="宝塔地址">
                        <el-input v-model="form.bt_address" placeholder="宝塔地址" autocomplete="off"></el-input>
                    </el-form-item>
                    <el-form-item label="过期时间">
                        <br>
                        <el-date-picker style="width: 100%;" value-format="yyyy-MM-dd" v-model="form.expiration_date"
                            type="date" placeholder="选择日期">
                        </el-date-picker>
                    </el-form-item>
                    <el-form-item label="备注信息">
                        <el-input v-model="form.info" placeholder="备注信息" autocomplete="off"></el-input>
                    </el-form-item>
                </el-form>
                <div style="display: flex; justify-content: flex-end;">
                    <el-button @click="drawer = false">取消操作</el-button>
                    <el-button type="primary" @click="submit">确定设置</el-button>
                </div>
            </div>
        </el-drawer>
    </div>
</template>

<script>
import ManageHeaderMenu from './ManageHeaderMenu.vue';
import ManageMenu from './ManageMenu.vue';
import Api from "@/apis"

export default {
    data() {
        return {
            pageName: "服务器实例",
            tableData: [],
            drawer: false,
            pagination: {
                page: 1,
                page_size: 10,
                total: 0,
            },
            form: {
                id: '',
                ip: '',
                operator: '',
                price: '',
                system: '',
                root_username: '',
                root_password: '',
                bt_username: '',
                bt_password: '',
                bt_address: '',
                expiration_date: '',
                info: ''
            }
        }
    },
    filters: {
        formatPrice(value) {
            return value.toFixed(2);
        }
    },
    methods: {
        handleClose(done) {
            this.clearForm()
            done()
        },
        filterBlank() {
            Object.keys(this.form).forEach(key => {
                if (typeof this.form[key] === 'string') {
                    this.form[key] = this.form[key].trim();
                }
            });
        },
        refresh() {
            this.selectTableData()
        },
        changePage(page) {
            this.pagination.page = page
            this.selectTableData()
        },
        isFilledForm() {
            for (let key in this.form) {
                if (Object.prototype.hasOwnProperty.call(this.form, key)) {
                    if (this.form[key] === '' && key !== 'id') {
                        return true
                    }
                }
            }
            return false;
        },
        clearForm() {
            Object.keys(this.form).forEach(key => {
                this.form[key] = '';
            });
        },
        submit() {
            if (this.isFilledForm()) {
                this.$message({ message: "填写数据存在空缺", type: 'warning' });
                return
            } else {
                this.filterBlank()
            }
            if (this.form.id) {
                Api.updateInstance(this.form).then(res => {
                    if (res.data.code == 200) {
                        this.selectTableData()
                        this.drawer = false
                        this.$message({ message: res.data.message, type: 'success' });
                    } else {
                        this.$message({ message: res.data.message, type: 'error' });
                    }
                }).catch(() => {
                    Api.feedback(this)
                })
            } else {
                Api.insertInstance(this.form).then(res => {
                    if (res.data.code == 200) {
                        this.selectTableData()
                        this.drawer = false
                        this.$message({ message: res.data.message, type: 'success' });
                    } else {
                        this.$message({ message: res.data.message, type: 'error' });
                    }
                }).catch(() => {
                    Api.feedback(this)
                })
            }
        },
        deleteData(data) {
            Api.deleteInstance({
                id: data.id
            }).then(res => {
                if (res.data.code == 200) {
                    this.selectTableData()
                    this.$message({ message: res.data.message, type: 'success' });
                } else {
                    this.$message({ message: res.data.message, type: 'error' });
                }
            }).catch(() => {
                Api.feedback(this)
            })
        },
        updateData(data) {
            this.drawer = true
            this.form = Object.assign({}, data);
        },
        selectTableData() {
            Api.selectInstance({
                page: this.pagination.page,
                page_size: this.pagination.page_size
            }).then(res => {
                if (res.data.code == 200) {
                    this.$message({ message: res.data.message, type: 'success' });
                    this.tableData = res.data.data.table_data
                    this.pagination.total = res.data.data.total
                } else {
                    this.$message({ message: res.data.message, type: 'error' });
                }
            }).catch(() => {
                Api.feedback(this)
            })
        }
    },
    mounted() {
        this.selectTableData()
    },
    components: {
        ManageHeaderMenu,
        ManageMenu
    }
}
</script>

<style scoped>
.main {
    justify-content: space-between;
    display: flex;
}

.content {
    flex: 1;
    overflow-y: scroll;
    height: calc(100vh - 60px);
}

.content-title {
    height: 60px;
    background-color: #ffffff;
    display: flex;
    align-items: center;
    padding: 0 20px;
    justify-content: space-between;
    display: flex;
}

.content-title span {
    font-size: 20px;
}

.custom-form {
    padding: 20px;
}

.table-button {
    margin: 0 5px;
    padding: 5px 10px;
}
</style>
